export default {"src":"/customer-services/_next/static/media/logo-john-lewis-opticians.c14bee35.svg","height":13,"width":104,"blurWidth":0,"blurHeight":0};